// source: tprmquestionnaire/vendor_questionnaire_received.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var tprmquestionnaire_questionnaire_internal_pb = require('../tprmquestionnaire/questionnaire_internal_pb.js');
goog.object.extend(proto, tprmquestionnaire_questionnaire_internal_pb);
var tprmquestionnaire_tprmquestionnaire_pb = require('../tprmquestionnaire/tprmquestionnaire_pb.js');
goog.object.extend(proto, tprmquestionnaire_tprmquestionnaire_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.EditImportedQuestionnaireRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.EditImportedQuestionnaireRequest.AnswerDisposition', null, global);
goog.exportSymbol('proto.tprmquestionnaire.EditImportedQuestionnaireRequest.EditCase', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorAnswerAttachment', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorFormConditionRule', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorFormOption', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorFormQuestion', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorFormSection', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ReceivedVendorSupplementalInput', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.displayName = 'proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.displayName = 'proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.displayName = 'proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.displayName = 'proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorFormOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ReceivedVendorFormOption.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorFormOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorFormOption.displayName = 'proto.tprmquestionnaire.ReceivedVendorFormOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorSupplementalInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorSupplementalInput.displayName = 'proto.tprmquestionnaire.ReceivedVendorSupplementalInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorFormConditionRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorFormConditionRule.displayName = 'proto.tprmquestionnaire.ReceivedVendorFormConditionRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ReceivedVendorFormQuestion.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorFormQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorFormQuestion.displayName = 'proto.tprmquestionnaire.ReceivedVendorFormQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorAnswerAttachment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.displayName = 'proto.tprmquestionnaire.ReceivedVendorAnswerAttachment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorFormSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ReceivedVendorFormSection.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorFormSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorFormSection.displayName = 'proto.tprmquestionnaire.ReceivedVendorFormSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.displayName = 'proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.displayName = 'proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.displayName = 'proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_);
};
goog.inherits(proto.tprmquestionnaire.EditImportedQuestionnaireRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.EditImportedQuestionnaireRequest.displayName = 'proto.tprmquestionnaire.EditImportedQuestionnaireRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.displayName = 'proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.displayName = 'proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.displayName = 'proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.displayName = 'proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.displayName = 'proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.displayName = 'proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.displayName = 'proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.displayName = 'proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.displayName = 'proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.displayName = 'proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.displayName = 'proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.displayName = 'proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.displayName = 'proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.displayName = 'proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.displayName = 'proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.displayName = 'proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.displayName = 'proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.displayName = 'proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.displayName = 'proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.displayName = 'proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.displayName = 'proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.displayName = 'proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.displayName = 'proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.displayName = 'proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.displayName = 'proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.displayName = 'proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest;
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    questionnaireRequestDestinationId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dueDateMs: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assigneeName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    assigneeUserId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    requestingOrgName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    formStatus: jspb.Message.getFieldWithDefault(msg, 10, ""),
    statusNote: jspb.Message.getFieldWithDefault(msg, 11, ""),
    statusSetByName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    statusSetAtMs: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary;
  return proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestDestinationId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDateMs(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigneeName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigneeUserId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestingOrgName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormStatus(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusNote(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusSetByName(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStatusSetAtMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuestionnaireRequestDestinationId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDueDateMs();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAssigneeName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAssigneeUserId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRequestingOrgName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFormStatus();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStatusNote();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getStatusSetByName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getStatusSetAtMs();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getDisplayId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setDisplayId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string questionnaire_request_destination_id = 5;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getQuestionnaireRequestDestinationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setQuestionnaireRequestDestinationId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 due_date_ms = 6;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getDueDateMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setDueDateMs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string assignee_name = 7;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getAssigneeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setAssigneeName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string assignee_user_id = 8;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getAssigneeUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setAssigneeUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string requesting_org_name = 9;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getRequestingOrgName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setRequestingOrgName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string form_status = 10;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getFormStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setFormStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string status_note = 11;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getStatusNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setStatusNote = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string status_set_by_name = 12;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getStatusSetByName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setStatusSetByName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 status_set_at_ms = 13;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.getStatusSetAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.prototype.setStatusSetAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnairesList: jspb.Message.toObjectList(msg.getQuestionnairesList(),
    proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse;
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.deserializeBinaryFromReader);
      msg.addQuestionnaires(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnairesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ReceivedVendorQuestionnaireSummary questionnaires = 1;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary>}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.prototype.getQuestionnairesList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary>} value
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse} returns this
*/
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.prototype.setQuestionnairesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.prototype.addQuestionnaires = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.ReceivedVendorQuestionnaireSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.prototype.clearQuestionnairesList = function() {
  return this.setQuestionnairesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest;
  return proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorFormOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.ReceivedVendorSupplementalInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormOption}
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorFormOption;
  return proto.tprmquestionnaire.ReceivedVendorFormOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormOption}
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.ReceivedVendorSupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorSupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorFormOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.ReceivedVendorSupplementalInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string option_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.getOptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormOption} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.setOptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormOption} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 display_order = 3;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormOption} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ReceivedVendorSupplementalInput supplemental = 4;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorSupplementalInput>}
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorSupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorSupplementalInput, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorSupplementalInput>} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormOption} returns this
*/
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput}
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.ReceivedVendorSupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormOption} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormOption.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorSupplementalInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    required: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    isList: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput}
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorSupplementalInput;
  return proto.tprmquestionnaire.ReceivedVendorSupplementalInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput}
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequired(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorSupplementalInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequired();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsList();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string kind = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput} returns this
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.setKind = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput} returns this
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.setLabel = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput} returns this
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.clearLabel = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.hasLabel = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool required = 3;
 * @return {boolean}
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.getRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput} returns this
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.setRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool is_list = 4;
 * @return {boolean}
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.getIsList = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput} returns this
 */
proto.tprmquestionnaire.ReceivedVendorSupplementalInput.prototype.setIsList = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorFormConditionRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    dependsOnQuestionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    matchValue: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule}
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorFormConditionRule;
  return proto.tprmquestionnaire.ReceivedVendorFormConditionRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule}
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDependsOnQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorFormConditionRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDependsOnQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMatchValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string depends_on_question_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.prototype.getDependsOnQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.prototype.setDependsOnQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string match_value = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.prototype.getMatchValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormConditionRule.prototype.setMatchValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.repeatedFields_ = [5,6,8,10,12,20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorFormQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responseType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 4, 0),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.tprmquestionnaire.ReceivedVendorFormOption.toObject, includeInstance),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ReceivedVendorFormConditionRule.toObject, includeInstance),
    answerValue: jspb.Message.getFieldWithDefault(msg, 7, ""),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.ReceivedVendorSupplementalInput.toObject, includeInstance),
    supplementalText: jspb.Message.getFieldWithDefault(msg, 9, ""),
    attachmentsList: jspb.Message.toObjectList(msg.getAttachmentsList(),
    proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.toObject, includeInstance),
    tiAnswerRationale: jspb.Message.getFieldWithDefault(msg, 11, ""),
    citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation.toObject, includeInstance),
    answerOutcome: jspb.Message.getFieldWithDefault(msg, 13, 0),
    answerOutcomeRationale: jspb.Message.getFieldWithDefault(msg, 14, ""),
    confidence: jspb.Message.getFieldWithDefault(msg, 15, 0),
    confidenceReason: jspb.Message.getFieldWithDefault(msg, 16, ""),
    appropriateness: jspb.Message.getFieldWithDefault(msg, 17, 0),
    appropriatenessReason: jspb.Message.getFieldWithDefault(msg, 18, ""),
    confidenceOverride: jspb.Message.getFieldWithDefault(msg, 19, 0),
    confidenceCitationsList: jspb.Message.toObjectList(msg.getConfidenceCitationsList(),
    tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorFormQuestion;
  return proto.tprmquestionnaire.ReceivedVendorFormQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponseType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.ReceivedVendorFormOption;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorFormOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 6:
      var value = new proto.tprmquestionnaire.ReceivedVendorFormConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorFormConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerValue(value);
      break;
    case 8:
      var value = new proto.tprmquestionnaire.ReceivedVendorSupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorSupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplementalText(value);
      break;
    case 10:
      var value = new proto.tprmquestionnaire.ReceivedVendorAnswerAttachment;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.deserializeBinaryFromReader);
      msg.addAttachments(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTiAnswerRationale(value);
      break;
    case 12:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    case 13:
      var value = /** @type {!proto.tprmquestionnaire.ANSWER_OUTCOME} */ (reader.readEnum());
      msg.setAnswerOutcome(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerOutcomeRationale(value);
      break;
    case 15:
      var value = /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (reader.readEnum());
      msg.setConfidence(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfidenceReason(value);
      break;
    case 17:
      var value = /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (reader.readEnum());
      msg.setAppropriateness(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppropriatenessReason(value);
      break;
    case 19:
      var value = /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (reader.readEnum());
      msg.setConfidenceOverride(value);
      break;
    case 20:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation.deserializeBinaryFromReader);
      msg.addConfidenceCitations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorFormQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponseType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.ReceivedVendorFormOption.serializeBinaryToWriter
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.tprmquestionnaire.ReceivedVendorFormConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getAnswerValue();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.tprmquestionnaire.ReceivedVendorSupplementalInput.serializeBinaryToWriter
    );
  }
  f = message.getSupplementalText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.serializeBinaryToWriter
    );
  }
  f = message.getTiAnswerRationale();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation.serializeBinaryToWriter
    );
  }
  f = message.getAnswerOutcome();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getAnswerOutcomeRationale();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getConfidenceReason();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAppropriateness();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getAppropriatenessReason();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getConfidenceOverride();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getConfidenceCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string response_type = 3;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getResponseType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 display_order = 4;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated ReceivedVendorFormOption options = 5;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorFormOption>}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorFormOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorFormOption, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorFormOption>} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
*/
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormOption}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.ReceivedVendorFormOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * repeated ReceivedVendorFormConditionRule depends_on = 6;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorFormConditionRule>}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorFormConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorFormConditionRule, 6));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorFormConditionRule>} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
*/
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.tprmquestionnaire.ReceivedVendorFormConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * optional string answer_value = 7;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getAnswerValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setAnswerValue = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated ReceivedVendorSupplementalInput supplemental = 8;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorSupplementalInput>}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorSupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorSupplementalInput, 8));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorSupplementalInput>} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
*/
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorSupplementalInput}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.tprmquestionnaire.ReceivedVendorSupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};


/**
 * optional string supplemental_text = 9;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getSupplementalText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setSupplementalText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated ReceivedVendorAnswerAttachment attachments = 10;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment>}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getAttachmentsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorAnswerAttachment, 10));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment>} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
*/
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setAttachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.addAttachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.tprmquestionnaire.ReceivedVendorAnswerAttachment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.clearAttachmentsList = function() {
  return this.setAttachmentsList([]);
};


/**
 * optional string ti_answer_rationale = 11;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getTiAnswerRationale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setTiAnswerRationale = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated ReceivedVendorAnswerCitation citations = 12;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorAnswerCitation>}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorAnswerCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation, 12));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorAnswerCitation>} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
*/
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorAnswerCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerCitation}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.tprmquestionnaire.ReceivedVendorAnswerCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};


/**
 * optional ANSWER_OUTCOME answer_outcome = 13;
 * @return {!proto.tprmquestionnaire.ANSWER_OUTCOME}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getAnswerOutcome = function() {
  return /** @type {!proto.tprmquestionnaire.ANSWER_OUTCOME} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.tprmquestionnaire.ANSWER_OUTCOME} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setAnswerOutcome = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string answer_outcome_rationale = 14;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getAnswerOutcomeRationale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setAnswerOutcomeRationale = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional GRADE_BAND confidence = 15;
 * @return {!proto.tprmquestionnaire.GRADE_BAND}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getConfidence = function() {
  return /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.tprmquestionnaire.GRADE_BAND} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string confidence_reason = 16;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getConfidenceReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setConfidenceReason = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional GRADE_BAND appropriateness = 17;
 * @return {!proto.tprmquestionnaire.GRADE_BAND}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getAppropriateness = function() {
  return /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.tprmquestionnaire.GRADE_BAND} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setAppropriateness = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional string appropriateness_reason = 18;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getAppropriatenessReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setAppropriatenessReason = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional GRADE_BAND confidence_override = 19;
 * @return {!proto.tprmquestionnaire.GRADE_BAND}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getConfidenceOverride = function() {
  return /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.tprmquestionnaire.GRADE_BAND} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setConfidenceOverride = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * repeated ReceivedVendorAnswerCitation confidence_citations = 20;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorAnswerCitation>}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.getConfidenceCitationsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorAnswerCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.ReceivedVendorAnswerCitation, 20));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorAnswerCitation>} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
*/
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.setConfidenceCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorAnswerCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerCitation}
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.addConfidenceCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.tprmquestionnaire.ReceivedVendorAnswerCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormQuestion.prototype.clearConfidenceCitationsList = function() {
  return this.setConfidenceCitationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.toObject = function(includeInstance, msg) {
  var f, obj = {
    attachmentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    uploadedAtMs: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment}
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorAnswerAttachment;
  return proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment}
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUploadedAtMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUploadedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mime_type = 4;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 uploaded_at_ms = 5;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.getUploadedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorAnswerAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorAnswerAttachment.prototype.setUploadedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorFormSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    sectionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 6, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
    questionsList: jspb.Message.toObjectList(msg.getQuestionsList(),
    proto.tprmquestionnaire.ReceivedVendorFormQuestion.toObject, includeInstance),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ReceivedVendorFormConditionRule.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorFormSection;
  return proto.tprmquestionnaire.ReceivedVendorFormSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.ReceivedVendorFormQuestion;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorFormQuestion.deserializeBinaryFromReader);
      msg.addQuestions(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.ReceivedVendorFormConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorFormConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorFormSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSectionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getQuestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.ReceivedVendorFormQuestion.serializeBinaryToWriter
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.ReceivedVendorFormConditionRule.serializeBinaryToWriter
    );
  }
};


/**
 * optional string section_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.getSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.setSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 display_order = 3;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ReceivedVendorFormQuestion questions = 4;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorFormQuestion>}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.getQuestionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorFormQuestion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorFormQuestion, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorFormQuestion>} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection} returns this
*/
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.setQuestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormQuestion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormQuestion}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.addQuestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.ReceivedVendorFormQuestion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.clearQuestionsList = function() {
  return this.setQuestionsList([]);
};


/**
 * repeated ReceivedVendorFormConditionRule depends_on = 5;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorFormConditionRule>}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorFormConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorFormConditionRule, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorFormConditionRule>} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection} returns this
*/
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormConditionRule}
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.ReceivedVendorFormConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection} returns this
 */
proto.tprmquestionnaire.ReceivedVendorFormSection.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.tprmquestionnaire.ReceivedVendorFormSection.toObject, includeInstance),
    description: jspb.Message.getFieldWithDefault(msg, 6, ""),
    assigneeName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    receivedDateMs: jspb.Message.getFieldWithDefault(msg, 8, 0),
    dueDateMs: jspb.Message.getFieldWithDefault(msg, 9, 0),
    assigneeUserId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    hasUnsubmittedChanges: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    formStatus: jspb.Message.getFieldWithDefault(msg, 12, ""),
    requestingOrgName: jspb.Message.getFieldWithDefault(msg, 13, ""),
    isImported: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    statusNote: jspb.Message.getFieldWithDefault(msg, 15, ""),
    statusSetByName: jspb.Message.getFieldWithDefault(msg, 16, ""),
    statusSetAtMs: jspb.Message.getFieldWithDefault(msg, 17, 0),
    contentRevision: jspb.Message.getFieldWithDefault(msg, 18, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse;
  return proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.ReceivedVendorFormSection;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorFormSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigneeName(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReceivedDateMs(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDateMs(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigneeUserId(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasUnsubmittedChanges(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestingOrgName(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsImported(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusNote(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusSetByName(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStatusSetAtMs(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContentRevision(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.ReceivedVendorFormSection.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAssigneeName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getReceivedDateMs();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getDueDateMs();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getAssigneeUserId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getHasUnsubmittedChanges();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getFormStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getRequestingOrgName();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getIsImported();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getStatusNote();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getStatusSetByName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getStatusSetAtMs();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getContentRevision();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getDisplayId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setDisplayId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ReceivedVendorFormSection sections = 5;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorFormSection>}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorFormSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorFormSection, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorFormSection>} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
*/
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.ReceivedVendorFormSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string assignee_name = 7;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getAssigneeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setAssigneeName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 received_date_ms = 8;
 * @return {number}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getReceivedDateMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setReceivedDateMs = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 due_date_ms = 9;
 * @return {number}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getDueDateMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setDueDateMs = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string assignee_user_id = 10;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getAssigneeUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setAssigneeUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool has_unsubmitted_changes = 11;
 * @return {boolean}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getHasUnsubmittedChanges = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setHasUnsubmittedChanges = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string form_status = 12;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getFormStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setFormStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string requesting_org_name = 13;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getRequestingOrgName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setRequestingOrgName = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool is_imported = 14;
 * @return {boolean}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getIsImported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setIsImported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string status_note = 15;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getStatusNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setStatusNote = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string status_set_by_name = 16;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getStatusSetByName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setStatusSetByName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 status_set_at_ms = 17;
 * @return {number}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getStatusSetAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setStatusSetAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 content_revision = 18;
 * @return {number}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.getContentRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.prototype.setContentRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assigneeUserId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    formStatus: jspb.Message.getFieldWithDefault(msg, 6, ""),
    statusNote: jspb.Message.getFieldWithDefault(msg, 7, ""),
    name: jspb.Message.getFieldWithDefault(msg, 8, ""),
    requestingOrgName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    dueDateMs: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest;
  return proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigneeUserId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusNote(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestingOrgName(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDateMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeInt64(
      10,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.setDescription = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.clearDescription = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string assignee_user_id = 3;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.getAssigneeUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.setAssigneeUserId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.clearAssigneeUserId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.hasAssigneeUserId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string form_status = 6;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.getFormStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.setFormStatus = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.clearFormStatus = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.hasFormStatus = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string status_note = 7;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.getStatusNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.setStatusNote = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.clearStatusNote = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.hasStatusNote = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string name = 8;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.setName = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.clearName = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string requesting_org_name = 9;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.getRequestingOrgName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.setRequestingOrgName = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.clearRequestingOrgName = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.hasRequestingOrgName = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional int64 due_date_ms = 10;
 * @return {number}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.getDueDateMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.setDueDateMs = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.clearDueDateMs = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest.prototype.hasDueDateMs = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    assigneeName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse;
  return proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigneeName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string assignee_name = 1;
 * @return {string}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.prototype.getAssigneeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.prototype.setAssigneeName = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.prototype.clearAssigneeName = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.prototype.hasAssigneeName = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_ = [[3,4,5,7,8,9,10]];

/**
 * @enum {number}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.EditCase = {
  EDIT_NOT_SET: 0,
  QUESTION: 3,
  REORDER_SECTIONS: 4,
  MOVE_QUESTION: 5,
  SECTION: 7,
  ADD_QUESTION: 8,
  DELETE_QUESTION: 9,
  DELETE_SECTION: 10
};

/**
 * @return {proto.tprmquestionnaire.EditImportedQuestionnaireRequest.EditCase}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getEditCase = function() {
  return /** @type {proto.tprmquestionnaire.EditImportedQuestionnaireRequest.EditCase} */(jspb.Message.computeOneofCase(this, proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.EditImportedQuestionnaireRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expectedRevision: jspb.Message.getFieldWithDefault(msg, 2, 0),
    question: (f = msg.getQuestion()) && tprmquestionnaire_tprmquestionnaire_pb.FormQuestionInput.toObject(includeInstance, f),
    reorderSections: (f = msg.getReorderSections()) && tprmquestionnaire_tprmquestionnaire_pb.ReorderQuestionnaireFormSectionsRequest.toObject(includeInstance, f),
    moveQuestion: (f = msg.getMoveQuestion()) && tprmquestionnaire_tprmquestionnaire_pb.MoveQuestionnaireFormQuestionRequest.toObject(includeInstance, f),
    section: (f = msg.getSection()) && tprmquestionnaire_tprmquestionnaire_pb.FormSectionInput.toObject(includeInstance, f),
    addQuestion: (f = msg.getAddQuestion()) && tprmquestionnaire_tprmquestionnaire_pb.SaveQuestionnaireFormQuestionRequest.toObject(includeInstance, f),
    deleteQuestion: (f = msg.getDeleteQuestion()) && tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormQuestionRequest.toObject(includeInstance, f),
    deleteSection: (f = msg.getDeleteSection()) && tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormSectionRequest.toObject(includeInstance, f),
    answerDisposition: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.EditImportedQuestionnaireRequest;
  return proto.tprmquestionnaire.EditImportedQuestionnaireRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpectedRevision(value);
      break;
    case 3:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.FormQuestionInput;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.FormQuestionInput.deserializeBinaryFromReader);
      msg.setQuestion(value);
      break;
    case 4:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.ReorderQuestionnaireFormSectionsRequest;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.ReorderQuestionnaireFormSectionsRequest.deserializeBinaryFromReader);
      msg.setReorderSections(value);
      break;
    case 5:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.MoveQuestionnaireFormQuestionRequest;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.MoveQuestionnaireFormQuestionRequest.deserializeBinaryFromReader);
      msg.setMoveQuestion(value);
      break;
    case 7:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.FormSectionInput;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.FormSectionInput.deserializeBinaryFromReader);
      msg.setSection(value);
      break;
    case 8:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.SaveQuestionnaireFormQuestionRequest;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.SaveQuestionnaireFormQuestionRequest.deserializeBinaryFromReader);
      msg.setAddQuestion(value);
      break;
    case 9:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormQuestionRequest;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormQuestionRequest.deserializeBinaryFromReader);
      msg.setDeleteQuestion(value);
      break;
    case 10:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormSectionRequest;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormSectionRequest.deserializeBinaryFromReader);
      msg.setDeleteSection(value);
      break;
    case 6:
      var value = /** @type {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest.AnswerDisposition} */ (reader.readEnum());
      msg.setAnswerDisposition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.EditImportedQuestionnaireRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpectedRevision();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getQuestion();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.FormQuestionInput.serializeBinaryToWriter
    );
  }
  f = message.getReorderSections();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.ReorderQuestionnaireFormSectionsRequest.serializeBinaryToWriter
    );
  }
  f = message.getMoveQuestion();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.MoveQuestionnaireFormQuestionRequest.serializeBinaryToWriter
    );
  }
  f = message.getSection();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.FormSectionInput.serializeBinaryToWriter
    );
  }
  f = message.getAddQuestion();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.SaveQuestionnaireFormQuestionRequest.serializeBinaryToWriter
    );
  }
  f = message.getDeleteQuestion();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormQuestionRequest.serializeBinaryToWriter
    );
  }
  f = message.getDeleteSection();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormSectionRequest.serializeBinaryToWriter
    );
  }
  f = message.getAnswerDisposition();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.AnswerDisposition = {
  UNSPECIFIED: 0,
  KEEP: 1,
  CLEAR: 2
};

/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 expected_revision = 2;
 * @return {number}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getExpectedRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setExpectedRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional FormQuestionInput question = 3;
 * @return {?proto.tprmquestionnaire.FormQuestionInput}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getQuestion = function() {
  return /** @type{?proto.tprmquestionnaire.FormQuestionInput} */ (
    jspb.Message.getWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.FormQuestionInput, 3));
};


/**
 * @param {?proto.tprmquestionnaire.FormQuestionInput|undefined} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
*/
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setQuestion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.clearQuestion = function() {
  return this.setQuestion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.hasQuestion = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ReorderQuestionnaireFormSectionsRequest reorder_sections = 4;
 * @return {?proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getReorderSections = function() {
  return /** @type{?proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest} */ (
    jspb.Message.getWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.ReorderQuestionnaireFormSectionsRequest, 4));
};


/**
 * @param {?proto.tprmquestionnaire.ReorderQuestionnaireFormSectionsRequest|undefined} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
*/
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setReorderSections = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.clearReorderSections = function() {
  return this.setReorderSections(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.hasReorderSections = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional MoveQuestionnaireFormQuestionRequest move_question = 5;
 * @return {?proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getMoveQuestion = function() {
  return /** @type{?proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest} */ (
    jspb.Message.getWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.MoveQuestionnaireFormQuestionRequest, 5));
};


/**
 * @param {?proto.tprmquestionnaire.MoveQuestionnaireFormQuestionRequest|undefined} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
*/
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setMoveQuestion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.clearMoveQuestion = function() {
  return this.setMoveQuestion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.hasMoveQuestion = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional FormSectionInput section = 7;
 * @return {?proto.tprmquestionnaire.FormSectionInput}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getSection = function() {
  return /** @type{?proto.tprmquestionnaire.FormSectionInput} */ (
    jspb.Message.getWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.FormSectionInput, 7));
};


/**
 * @param {?proto.tprmquestionnaire.FormSectionInput|undefined} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
*/
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setSection = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.clearSection = function() {
  return this.setSection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.hasSection = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SaveQuestionnaireFormQuestionRequest add_question = 8;
 * @return {?proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getAddQuestion = function() {
  return /** @type{?proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest} */ (
    jspb.Message.getWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.SaveQuestionnaireFormQuestionRequest, 8));
};


/**
 * @param {?proto.tprmquestionnaire.SaveQuestionnaireFormQuestionRequest|undefined} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
*/
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setAddQuestion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.clearAddQuestion = function() {
  return this.setAddQuestion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.hasAddQuestion = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional DeleteQuestionnaireFormQuestionRequest delete_question = 9;
 * @return {?proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getDeleteQuestion = function() {
  return /** @type{?proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest} */ (
    jspb.Message.getWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormQuestionRequest, 9));
};


/**
 * @param {?proto.tprmquestionnaire.DeleteQuestionnaireFormQuestionRequest|undefined} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
*/
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setDeleteQuestion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.clearDeleteQuestion = function() {
  return this.setDeleteQuestion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.hasDeleteQuestion = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional DeleteQuestionnaireFormSectionRequest delete_section = 10;
 * @return {?proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getDeleteSection = function() {
  return /** @type{?proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest} */ (
    jspb.Message.getWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.DeleteQuestionnaireFormSectionRequest, 10));
};


/**
 * @param {?proto.tprmquestionnaire.DeleteQuestionnaireFormSectionRequest|undefined} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
*/
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setDeleteSection = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.tprmquestionnaire.EditImportedQuestionnaireRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.clearDeleteSection = function() {
  return this.setDeleteSection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.hasDeleteSection = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional AnswerDisposition answer_disposition = 6;
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest.AnswerDisposition}
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.getAnswerDisposition = function() {
  return /** @type {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest.AnswerDisposition} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest.AnswerDisposition} value
 * @return {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.EditImportedQuestionnaireRequest.prototype.setAnswerDisposition = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    supplementalText: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest;
  return proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplementalText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} returns this
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} returns this
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string supplemental_text = 3;
 * @return {string}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.getSupplementalText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} returns this
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.setSupplementalText = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} returns this
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.clearSupplementalText = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest.prototype.hasSupplementalText = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse;
  return proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest;
  return proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse;
  return proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse}
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest;
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    submittedAtMs: jspb.Message.getFieldWithDefault(msg, 2, 0),
    submittedByName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    questionsAnswered: jspb.Message.getFieldWithDefault(msg, 4, 0),
    questionsTotal: jspb.Message.getFieldWithDefault(msg, 5, 0),
    attachedDocumentsCount: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary;
  return proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmissionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedAtMs(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedByName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionsAnswered(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionsTotal(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttachedDocumentsCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubmittedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSubmittedByName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuestionsAnswered();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getQuestionsTotal();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getAttachedDocumentsCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string submission_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.getSubmissionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 submitted_at_ms = 2;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.getSubmittedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.setSubmittedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string submitted_by_name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.getSubmittedByName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.setSubmittedByName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 questions_answered = 4;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.getQuestionsAnswered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.setQuestionsAnswered = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 questions_total = 5;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.getQuestionsTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.setQuestionsTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 attached_documents_count = 6;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.getAttachedDocumentsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.prototype.setAttachedDocumentsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionsList: jspb.Message.toObjectList(msg.getVersionsList(),
    proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse;
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.deserializeBinaryFromReader);
      msg.addVersions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ReceivedVendorQuestionnaireVersionSummary versions = 1;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary>}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.prototype.getVersionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary>} value
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse} returns this
*/
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.prototype.setVersionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.prototype.addVersions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.ReceivedVendorQuestionnaireVersionSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.prototype.clearVersionsList = function() {
  return this.setVersionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    submissionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest;
  return proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmissionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubmissionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string submission_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.prototype.getSubmissionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.tprmquestionnaire.ReceivedVendorFormSection.toObject, includeInstance),
    submittedAtMs: jspb.Message.getFieldWithDefault(msg, 4, 0),
    submittedByName: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse;
  return proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.tprmquestionnaire.ReceivedVendorFormSection;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorFormSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedAtMs(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedByName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tprmquestionnaire.ReceivedVendorFormSection.serializeBinaryToWriter
    );
  }
  f = message.getSubmittedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSubmittedByName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string display_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.getDisplayId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.setDisplayId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ReceivedVendorFormSection sections = 3;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorFormSection>}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorFormSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorFormSection, 3));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorFormSection>} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse} returns this
*/
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorFormSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorFormSection}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tprmquestionnaire.ReceivedVendorFormSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};


/**
 * optional int64 submitted_at_ms = 4;
 * @return {number}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.getSubmittedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.setSubmittedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string submitted_by_name = 5;
 * @return {string}
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.getSubmittedByName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse} returns this
 */
proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.prototype.setSubmittedByName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
    authorSide: jspb.Message.getFieldWithDefault(msg, 5, ""),
    authorDisplayName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    body: jspb.Message.getFieldWithDefault(msg, 7, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
    isDraft: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    isUnread: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment;
  return proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorSide(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorDisplayName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDraft(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsUnread(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAuthorSide();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAuthorDisplayName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getIsDraft();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIsUnread();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_request_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 section_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 question_number = 4;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string author_side = 5;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getAuthorSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setAuthorSide = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string author_display_name = 6;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getAuthorDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setAuthorDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string body = 7;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool is_draft = 9;
 * @return {boolean}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getIsDraft = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setIsDraft = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool is_unread = 10;
 * @return {boolean}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.getIsUnread = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.prototype.setIsUnread = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    body: jspb.Message.getFieldWithDefault(msg, 4, ""),
    expectedRevision: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest;
  return proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpectedRevision(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExpectedRevision();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 section_number = 2;
 * @return {number}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 question_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string body = 4;
 * @return {string}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 expected_revision = 5;
 * @return {number}
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.getExpectedRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest.prototype.setExpectedRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest;
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 section_number = 2;
 * @return {number}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 question_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentsList: jspb.Message.toObjectList(msg.getCommentsList(),
    proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse;
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.deserializeBinaryFromReader);
      msg.addComments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ReceivedVendorQuestionnaireComment comments = 1;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment>}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.prototype.getCommentsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment>} value
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse} returns this
*/
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.prototype.setCommentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.prototype.addComments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.prototype.clearCommentsList = function() {
  return this.setCommentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest}
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest;
  return proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest}
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string comment_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest} returns this
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse}
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse;
  return proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse}
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    expectedRevision: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest;
  return proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpectedRevision(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getExpectedRevision();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} returns this
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 section_number = 2;
 * @return {number}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} returns this
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} returns this
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 question_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} returns this
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} returns this
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 expected_revision = 4;
 * @return {number}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.getExpectedRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} returns this
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest.prototype.setExpectedRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse;
  return proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    file: msg.getFile_asB64(),
    fileName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isSupplemental: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest;
  return proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFile(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSupplemental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFile_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsSupplemental();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string question_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes file = 3;
 * @return {!(string|Uint8Array)}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.getFile = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes file = 3;
 * This is a type-conversion wrapper around `getFile()`
 * @return {string}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.getFile_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFile()));
};


/**
 * optional bytes file = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFile()`
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.getFile_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFile()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.setFile = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional string file_name = 4;
 * @return {string}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string mime_type = 5;
 * @return {string}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_supplemental = 6;
 * @return {boolean}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.getIsSupplemental = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest.prototype.setIsSupplemental = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    attachmentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse;
  return proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse} returns this
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse} returns this
 */
proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    attachmentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest;
  return proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string attachment_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse;
  return proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest;
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse;
  return proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment;
      reader.readMessage(value,proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ReceivedVendorQuestionnaireAttachment items = 1;
 * @return {!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment>}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment>} value
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse} returns this
*/
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment}
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse} returns this
 */
proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.toObject = function(includeInstance, msg) {
  var f, obj = {
    attachmentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
    sectionName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 7, 0),
    questionId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    questionText: jspb.Message.getFieldWithDefault(msg, 9, ""),
    answerValue: jspb.Message.getFieldWithDefault(msg, 10, ""),
    uploadedAtMs: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment;
  return proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectionName(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionText(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerValue(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUploadedAtMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSectionNumber();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSectionName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getQuestionNumber();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getQuestionText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAnswerValue();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUploadedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mime_type = 4;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 section_number = 5;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setSectionNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string section_name = 6;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getSectionName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setSectionName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 question_number = 7;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string question_id = 8;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string question_text = 9;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getQuestionText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setQuestionText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string answer_value = 10;
 * @return {string}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getAnswerValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setAnswerValue = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 uploaded_at_ms = 11;
 * @return {number}
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.getUploadedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment} returns this
 */
proto.tprmquestionnaire.ReceivedVendorQuestionnaireAttachment.prototype.setUploadedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    attachmentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest;
  return proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string attachment_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest} returns this
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    file: msg.getFile_asB64(),
    fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse;
  return proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFile(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFile_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bytes file = 1;
 * @return {!(string|Uint8Array)}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.getFile = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes file = 1;
 * This is a type-conversion wrapper around `getFile()`
 * @return {string}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.getFile_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFile()));
};


/**
 * optional bytes file = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFile()`
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.getFile_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFile()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse} returns this
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.setFile = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse} returns this
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mime_type = 3;
 * @return {string}
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse} returns this
 */
proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.tprmquestionnaire);
